import { http } from '../../config/axios'

export interface FaturaManualItem {
  quantidade: number
  descricao: string
  valorUnitario: number
}

export interface FaturaManualRequest {
  idCliente: string
  idFaturamento: string
  tipoFaturaManual: string
  itens: FaturaManualItem[]
}

export default function postFaturaManualService(
  request: FaturaManualRequest
): Promise<string> {
  return http
    .post('/api/fatura/manual', request)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro ao criar fatura manual', error)
      throw Error(error.response?.data)
    })
}
